(function () {
  const hero = document.querySelector("[data-hero]");
  if (!hero) return;

  const video = hero.querySelector("[data-hero-video]");

  function playHeroVideo() {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.removeAttribute("controls");

    const attempt = video.play();
    if (attempt && typeof attempt.catch === "function") {
      attempt.catch(function () {
        // Retry once media can play — common on iOS Safari
        const onReady = function () {
          video.play().catch(function () {});
          video.removeEventListener("canplay", onReady);
          video.removeEventListener("loadeddata", onReady);
        };
        video.addEventListener("canplay", onReady);
        video.addEventListener("loadeddata", onReady);
      });
    }
  }

  playHeroVideo();
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) playHeroVideo();
  });
  window.addEventListener("pageshow", playHeroVideo);

  const swiperEl = hero.querySelector("[data-hero-swiper]");
  if (!swiperEl || typeof Swiper === "undefined") return;

  const btnPrev = hero.querySelector("[data-hero-prev]");
  const btnNext = hero.querySelector("[data-hero-next]");
  const btnPause = hero.querySelector("[data-hero-pause]");
  const iconPause = btnPause && btnPause.querySelector("[data-icon-pause]");
  const iconPlay = btnPause && btnPause.querySelector("[data-icon-play]");
  const cta = hero.querySelector("[data-hero-cta]");
  const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
  let isAutoplayPaused = false;

  const swiper = new Swiper(swiperEl, {
    loop: slideCount > 1,
    slidesPerView: 1,
    allowTouchMove: slideCount > 1,
    speed: 500,
    autoplay:
      slideCount > 1
        ? {
            delay: 5000,
            disableOnInteraction: false,
          }
        : false,
  });

  function syncCta() {
    if (!cta) return;
    const activeSlide = swiper.slides[swiper.activeIndex];
    const url = activeSlide && activeSlide.getAttribute("data-product-url");
    if (url) cta.setAttribute("href", url);
  }

  syncCta();
  swiper.on("slideChange", syncCta);

  if (btnPrev) {
    btnPrev.addEventListener("click", function () {
      swiper.slidePrev();
    });
  }

  if (btnNext) {
    btnNext.addEventListener("click", function () {
      swiper.slideNext();
    });
  }

  if (btnPause) {
    btnPause.addEventListener("click", function () {
      if (isAutoplayPaused) {
        swiper.autoplay.start();
        isAutoplayPaused = false;
        if (iconPause) iconPause.removeAttribute("hidden");
        if (iconPlay) iconPlay.setAttribute("hidden", "");
        btnPause.setAttribute("aria-label", "Pause autoplay");
      } else {
        swiper.autoplay.stop();
        isAutoplayPaused = true;
        if (iconPause) iconPause.setAttribute("hidden", "");
        if (iconPlay) iconPlay.removeAttribute("hidden");
        btnPause.setAttribute("aria-label", "Resume autoplay");
      }
    });
  }
})();
